import Vue from 'vue'
import App from './App.vue'

import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'
import '!style-loader!css-loader!./flatpickr.css'

Vue.use(vueCustomElement);
Vue.customElement('tn-quick', App)


// WEBPACK FOOTER //
// ./src/main.js